import axios from "./AxiosInstance"

const getAllPostByUserId = ({ axisId, postTypeId, postCategoryId, isViewed, userId, conclusionId }) => {
    let url = `api/posts?paginated=false&userId=${userId}`

    if (axisId && axisId !== -1) {
        url += `&axisId=${axisId}`
    }

    if (postTypeId) {
        url += `&postTypeId=${postTypeId}`
    }

    if (postCategoryId) {
        url += `&postCategoryId=${postCategoryId}`
    }

    if (conclusionId) {
        url += `&conclusionId=${conclusionId}`
    }

    if (isViewed !== undefined && isViewed !== null) {
        isViewed = isViewed ? 1 : 0
        url += `&isViewed=${isViewed}`
    }

    console.log({ urlBeMedia: url })

    return axios.get(url)
}

const getCategories = () => axios.get(`api/postCategories`)
const getDetails = (id) => axios.get(`api/posts/${id}`)
const setViewed = (postId) => axios.post(`api/postViews`, { postId: postId })
const getAllViewed = (userId) => axios.get(`api/postViews?userId=${userId}`)
const getAllTypes = () => axios.get("api/postTypes?paginated=false")
const getSocialMedias = () => axios.get(`api/socialMedias/facebookPosts`)

export const PostService = {
    getAllPostByUserId,
    setViewed,
    getAllViewed,
    getDetails,
    getAllTypes,
    getCategories,
    getSocialMedias
}
